import { useState } from "react";
import { ArrowRight, Menu, X } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";
import { useDialogs } from "@/lib/dialogs";
import { LANGUAGES } from "@/config/regions";
import { AyndriLogo } from "@/components/brand/AyndriLogo";

const LINKS = [["solutions", "nav_solutions"], ["workflow", "nav_workflow"], ["sarvam", "nav_sarvam"], ["pricing", "nav_pricing"], ["india", "nav_india"], ["integration", "nav_app"]];

export const Header = () => {
  const { t, lang, setLang } = useI18n();
  const open = useDialogs();
  const [menu, setMenu] = useState(false);

  return (
    <header data-testid="site-header">
      <a href="#top" className="brand" aria-label="Ayndri home" data-testid="brand-home-link">
        <AyndriLogo testId="header-logo" />
      </a>
      <nav className={`navlinks ${menu ? "open" : ""}`} data-testid="main-nav">
        {LINKS.map(([id, k]) => (
          <a key={id} href={`#${id}`} onClick={() => setMenu(false)} data-testid={`nav-${id}-link`}>{t(k)}</a>
        ))}
      </nav>
      <div className="rightnav">
        <select aria-label="Select language" value={lang} onChange={(e) => setLang(e.target.value)} data-testid="language-select">
          {LANGUAGES.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
        </select>
        <button className="btn clear small connectbtn" onClick={() => open("connect")} data-testid="header-connect-button">{t("connect")}</button>
        <button className="btn gold small" onClick={() => open("onboard")} data-testid="header-get-started-button">{t("get_started")} <ArrowRight className="ic" /></button>
        <button className="menubtn" aria-label={menu ? "Close menu" : "Open menu"} aria-expanded={menu} onClick={() => setMenu(!menu)} data-testid="mobile-menu-button">
          {menu ? <X /> : <Menu />}
        </button>
      </div>
    </header>
  );
};
